import jwtDecode from 'jwt-decode';
import { createActions, createReducer } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions(
  {
    setTokens: ['tokens'],
    clearTokens: [],
  },
  {
    prefix: 'cb/auth/tokens/',
  },
);

const INITIAL_STATE = {
  refresh: null,
  access: null,
  refreshDecoded: null,
  accessDecoded: null,
};

// Safely decode JWTs — returns null instead of throwing when token is
// missing/null (e.g. Firebase sessions have no refresh token) or malformed.
const safeDecode = token => {
  try {
    return token ? jwtDecode(token) : null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export default createReducer(INITIAL_STATE, {
  [types.SET_TOKENS]: (_, { tokens }) => ({
    ...tokens,
    refreshDecoded: safeDecode(tokens.refresh),
    accessDecoded: safeDecode(tokens.access),
  }),
  [types.CLEAR_TOKENS]: () => INITIAL_STATE,
});